import { compose } from 'recompose';

import CategoryShow from './CategoryShow';

const enhance = compose();

export default enhance(CategoryShow);
